// import React, { createContext, useContext, useState, useEffect, useRef } from "react";
// const InactivityContext = createContext();

// export const InactivityProvider = ({ children }) => {
//   const [isActive, setIsActive] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const inactivityTimeoutRef = useRef(null);
// console.log("showModal", showModal);

//   const resetInactivityTimeout = () => {
//     try {

//       if (inactivityTimeoutRef.current) {
//         console.log("Clearing previous inactivity timeout");
//         clearTimeout(inactivityTimeoutRef.current);
//       }

//       inactivityTimeoutRef.current = setTimeout(() => {
//         console.log("User is inactive, showing modal");

//         const loginId = sessionStorage.getItem("loginID");
//         if (loginId) {
//           setIsActive(false);
//           setShowModal(true);
//         }
//       // }, 7 * 60 * 1000);
//       }, 5 * 1000);
//       // }, 60 * 60 * 1000);
//     } catch (error) { }
//   };


//   const handleActivity = () => {
//     setIsActive(true);
//     resetInactivityTimeout();
//   };

//   useEffect(() => {
//     window.addEventListener("mousemove", handleActivity);
//     window.addEventListener("keypress", handleActivity);
//     window.addEventListener("click", handleActivity);

//     resetInactivityTimeout();

//     return () => {
//       window.removeEventListener("mousemove", handleActivity);
//       window.removeEventListener("keypress", handleActivity);
//       window.removeEventListener("click", handleActivity);

//       if (inactivityTimeoutRef.current) {
//         clearTimeout(inactivityTimeoutRef.current);
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <InactivityContext.Provider value={{ isActive, showModal, setShowModal }}>
//       {children}
//     </InactivityContext.Provider>
//   );
// };

// export const useInactivity = () => useContext(InactivityContext);











// import React, { createContext, useContext, useState, useEffect, useRef } from "react";

// const InactivityContext = createContext();

// export const InactivityProvider = ({ children }) => {
//   const [isActive, setIsActive] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [currentTime, setCurrentTime] = useState("");
//   const inactivityTimeoutRef = useRef(null);
//   const intervalRef = useRef(null);

//   const resetInactivityTimeout = () => {
//     // console.log("Resetting inactivity timeout");

//     try {
//       if (inactivityTimeoutRef.current) {
//         clearTimeout(inactivityTimeoutRef.current);
//       }
//       inactivityTimeoutRef.current = setTimeout(() => {
//         const loginId = sessionStorage.getItem("loginID");
//         if (loginId) {
//           setIsActive(false);
//           setShowModal(true);
//           const now = new Date().getTime();
//           localStorage.setItem("inactivityStart", now.toString());
//         }
//         // }, 7 * 60 * 1000); 
//       }, 2 * 60 * 1000);
//       // },5 * 1000);
//     } catch (error) { }
//   };


//   const handleActivity = () => {
//     setIsActive(true);
//     console.log("User activity detected, resetting inactivity timeout");
//     // setShowModal(false);
//     resetInactivityTimeout();
//   };

//   useEffect(() => {
//     if (showModal) {
//       intervalRef.current = setInterval(() => {
//         const now = new Date();
//         setCurrentTime(now.toLocaleTimeString());
//         console.log("Current time:", now.toLocaleTimeString());

//         // ✅ Compare current time with localStorage value
//         const savedTime = localStorage.getItem("inactivityStart");
//         if (savedTime) {
//           const elapsed = (now.getTime() - parseInt(savedTime, 10)) / 1000;
//           console.log("Elapsed time in seconds:", elapsed);

//           if (elapsed > 100) {
//             // More than 100 seconds
//             console.warn("User inactive for too long. Logging out.");
//             localStorage.removeItem("inactivityStart");

//             // 👇 Perform logout or redirect here
//             setShowModal(false);
//             sessionStorage.removeItem("loginID");
//             sessionStorage.clear();
//             // Redirect to login page or perform logout action
//             window.location.href = "/"; // Replace with your logout route
//           }
//         }
//       }, 1000);
//     } else {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     }

//     return () => {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//       }
//     };
//   }, [showModal]);

//   useEffect(() => {
//     window.addEventListener("mousemove", handleActivity);
//     window.addEventListener("keypress", handleActivity);
//     window.addEventListener("click", handleActivity);

//     resetInactivityTimeout();

//     return () => {
//       window.removeEventListener("mousemove", handleActivity);
//       window.removeEventListener("keypress", handleActivity);
//       window.removeEventListener("click", handleActivity);

//       if (inactivityTimeoutRef.current) {
//         clearTimeout(inactivityTimeoutRef.current);
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return (
//     <InactivityContext.Provider
//       value={{ isActive, showModal, setShowModal, currentTime }}
//     >
//       {children}
//     </InactivityContext.Provider>
//   );
// };

// export const useInactivity = () => useContext(InactivityContext);




import React, { createContext, useContext, useState, useEffect, useRef } from "react";

const InactivityContext = createContext();

export const InactivityProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModalTimer, setShowModalTimer] = useState(0);
  const [currentTime, setCurrentTime] = useState("");
  const inactivityTimeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const globalInactivityRef = useRef(null);

  const resetInactivityTimeout = () => {
    try {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }

      inactivityTimeoutRef.current = setTimeout(() => {
        const loginId = sessionStorage.getItem("loginID");
        if (loginId) {
          setIsActive(false);
          setShowModal(true);
          const now = Date.now();
          localStorage.setItem("inactivityStart", now.toString());
        }
      }, 5 * 60 * 1000); // 5 minutes
    } catch (error) { }
  };
  // console.log("showModalTimer Inactive --->", showModalTimer);

  const handleActivity = () => {
    const now = Date.now();
    localStorage.setItem("lastActivityTime", now.toString());

    setIsActive(true);
    resetInactivityTimeout();
  };

  const checkGlobalInactivity = () => {
    const lastActivity = localStorage.getItem("lastActivityTime");
    if (lastActivity) {
      const now = Date.now();
      const elapsed = (now - parseInt(lastActivity, 10)) / 1000;
      setShowModalTimer(Math.floor(elapsed));
      if (elapsed > 420) {
        performLogout();
      }
    }
  };

  const performLogout = () => {
    localStorage.removeItem("lastActivityTime");
    localStorage.removeItem("inactivityStart");
    sessionStorage.clear();
    setShowModal(false);
    window.location.href = "/";
  };

  useEffect(() => {
    if (showModal) {
      intervalRef.current = setInterval(() => {
        const now = new Date();
        setCurrentTime(now.toLocaleTimeString());
        const savedTime = localStorage.getItem("inactivityStart");
        if (savedTime) {
          const elapsed = (now.getTime() - parseInt(savedTime, 10)) / 1000;
          if (elapsed > 120) {
            performLogout();
          }
        }
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [showModal]);

  useEffect(() => {
    const now = Date.now();
    localStorage.setItem("lastActivityTime", now.toString());
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("click", handleActivity);
    resetInactivityTimeout();
    globalInactivityRef.current = setInterval(checkGlobalInactivity, 1000);
    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("click", handleActivity);

      if (inactivityTimeoutRef.current) clearTimeout(inactivityTimeoutRef.current);
      if (globalInactivityRef.current) clearInterval(globalInactivityRef.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InactivityContext.Provider value={{ isActive, showModal, setShowModal, currentTime, showModalTimer }}>
      {children}
    </InactivityContext.Provider>
  );
};

export const useInactivity = () => useContext(InactivityContext);


